import React, { useEffect } from "react";
import { Page, PageHeader, Panel } from "../components/ui";

const GainCar = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://tuning-shop.com/media/js/iframe-loader.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Page>
      <PageHeader
        title="Gain"
        subtitle="Expected power and torque gains by vehicle"
        onBack={() => window.history.back()}
      />
      <Panel padded={false} className="overflow-hidden p-2">
        <iframe
          title="Tuning gain calculator"
          src="https://tuning-shop.com/iframe/iframe.php?user=5820"
          width="100%"
          height="auto"
          scrolling="no"
          className="min-h-[70vh] w-full rounded-[16px]"
          style={{ border: 0 }}
        ></iframe>
      </Panel>
    </Page>
  );
};

export default GainCar;
